import { createContext } from 'react'
import { IArtifacts } from '../model/IArtifacts'
import { PaymentFormDataObject } from './contextDataObjects/PaymentFormDataObject'
interface IPaymentFormData {
    CCType: { id: string, name: string, code: string }
    CCNum: string
    ExpMo: string
    ExpYr: string
    CVV: string
    Payor: string
    HfResponseCode: string
    HfDataKey: string
    HfErrorMessage: string
    Artifacts: IArtifacts
}
interface PaymentFormDataContextValue {
    paymentFormData: IPaymentFormData
    setPaymentFormData: React.Dispatch<React.SetStateAction<IPaymentFormData>>
}

const paymentFormDataContext = createContext<PaymentFormDataContextValue>({
    paymentFormData: PaymentFormDataObject,
    setPaymentFormData: () => { },
})

export default paymentFormDataContext
